import { create } from "zustand";
import { IUserPdf } from "@/types/user.types";

export const useUserPdf = create<IUserPdf>((set) => ({
  config: {},
  data: {
    id: null,
    dynamic: "1",
    name: "",
    pdf: "",
    redirect_type: "pdf",
    imageUrl: "",
  },
  setUserPdf: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setPdf: (val) => {
    set((state) => {
      return { ...state, pdf: val };
    });
  },
  setUrl: (val) => {
    set((state) => {
      return { ...state, url: val };
    });
  },
  setDelete: (val) => {
    set((state) => {
      delete state["data" as keyof typeof state][val];
      return state;
    });
  },
  setConfig: (val) => {
    set((state) => {
      return { ...state, config: { ...state.config, ...val } };
    });
  },
  destroyUserPdf: () => {
    set({
      config: {},
      data: {
        id: null,
        dynamic: "1",
        name: "",
        pdf: "",
        redirect_type: "pdf",
        imageUrl: "",
      },
    });
  },
}));
